export const colorParams  = {
  primary: 'bg-fuchsia-800',
  lightPrimary: 'bg-fuchsia-300',
  secondary: 'bg-blue-800',
  lightSecondary: 'bg-blue-300',
  accent: 'bg-pink-800',
  warn: 'bg-red-800',
  light: 'bg-gray-400',
  dark: 'bg-gray-800'
};

